import {createApi,fetchBaseQuery} from "@reduxjs/toolkit/query/react"

const cryptoApiHeades = {
    'X-RapidAPI-Key': '1f7e3d5b0amsh1647d51dfb56d98p12c19cjsnf0d589f4f09d',
    'X-RapidAPI-Host': 'coinranking1.p.rapidapi.com'
}


const baseUrl = 'https://coinranking1.p.rapidapi.com'

const createResquest = (url) => ({url, headers:cryptoApiHeades })

export const cryptoApi = createApi({
    reducerPath: "cryptoApi",
    baseQuery: fetchBaseQuery({baseUrl}),
    endpoints: (builder) => ({
        getCryptos: builder.query({
            query: (count)=> createResquest(`/coins?limit=${count}`)
        }),
        getExchanges: builder.query({
            query: () => createResquest(`/exchanges`)
        }),
        getCryptoDetails: builder.query({
            query: (coinId) => createResquest(`/coin/${coinId}`)
        })
    })
});


export const {
    useGetCryptosQuery,
    useGetCryptoDetailsQuery,
    useGetExchangesQuery
} = cryptoApi;